<template>
  <footer class="footer mt-auto">
    <div class="container">
            <span>Created by
                <a href="https://twitter.com/rdnpradipta">Ardian Pradipta</a>.


                If you want to contribute to this page, visit my
            <a href="https://github.com/rdnpradipta/salary-calculator-id">github</a>
            </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footer"
}
</script>
